import { LocalizedDatePipe } from "src/app/angular-core/utils/pipes/localized-date/localized-date.pipe";
import { append } from "./string.functions";
import { BasicXpacInfo } from "src/app/generated/CrossPoint.RemoteXpac.Server";

export function getXpacInfoStringIdAndInstallationDate(xpac: BasicXpacInfo, datePipe?: LocalizedDatePipe): string {
  let info: string = xpac.deviceId;

  if (xpac.firmware) {
    info = append(info, xpac.firmware, ' - ');
  }

  if (xpac.ccap) {
    info = append(info, "CCAP", ' - ');
  }

  if (xpac.installationDateUtc && datePipe) {
    info = append(info, datePipe.transform(xpac.installationDateUtc, 'shortDate'), ' - ');
  }

  info = append(info, xpac.storeCodes.storeId, ' - ');

  return info;
}

export function getXpacInfoStringAddressAndRetailer(xpac: BasicXpacInfo, showRetailer?: boolean): string {
  let info: string = "";

  if (xpac.storeAddress.city) {
    info = append(info, xpac.storeAddress.city, ' - ');
    info = append(info, xpac.storeAddress.street, ', ');
    info = append(info, xpac.storeAddress.streetNumber, ' ');
  }  

  if (showRetailer && xpac.retailerCompany) {
    info = append(info, xpac.retailerCompany, ' - ');
  }

  return info;
}